import { component$ } from "@builder.io/qwik";
import { Button } from "~/components/ui/button";

import type { QRL } from "@builder.io/qwik";

type CoachCardLockProps = {
  onClick$?: QRL<() => void>;
};

export const CoachCardLock = component$<CoachCardLockProps>(({ onClick$ }) => (
  <div
    preventdefault:click
    stoppropagation:click
    class="absolute top-0 h-full w-full bg-white/50 backdrop-blur-sm"
  >
    <div class="flex h-full w-full flex-col items-center justify-center gap-4 p-8">
      <Button variant="default" onClick$={onClick$}>
        Sign up to reveal
      </Button>
      <p class="text-basicblack-80 font-body-medium-14 text-center">
        Create an account to see all your matches!
      </p>
    </div>
  </div>
));
